import { Skeleton, Stack } from "@mui/material";
import { SectionTitle } from "Components/Loyalty/Shared/SectionTitle/SectionTitle";

type Props = {
  title: string;
  skeletonCount?: number;
};

export const LeaderboardSkeleton = ({ title, skeletonCount = 5 }: Props) => (
  <Stack gap={4}>
    <SectionTitle>{title}</SectionTitle>
    <Stack gap={2}>
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <Skeleton
          // biome-ignore lint/suspicious/noArrayIndexKey: fine here
          key={index}
          variant="rounded"
          height={42}
          sx={{ borderRadius: 1.25 }}
        />
      ))}
    </Stack>
  </Stack>
);
